import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApi } from "@/lib/api";
import { rm } from "@/pages/AkaunPage";

const masa = (iso) => new Date(iso).toLocaleString("ms-MY", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

const HASIL = {
  dipadankan: ["Dipadankan", "bg-emerald-100 text-emerald-800"],
  tidak_dipadankan: ["Tidak dipadankan", "bg-amber-100 text-amber-800"],
  pendua: ["Pendua", "bg-slate-100 text-slate-700"],
  jumlah_kurang: ["Jumlah tak cukup", "bg-orange-100 text-orange-800"],
  ditolak: ["Ditolak (token)", "bg-red-100 text-red-800"],
};
const FILTERS = [["", "Semua"], ...Object.entries(HASIL).map(([k, [l]]) => [k, l])];

export const WebhookLog = () => {
  const api = useApi();
  const [hasil, setHasil] = useState("");
  const [items, setItems] = useState(null);
  const [sel, setSel] = useState(null);
  useEffect(() => {
    setItems(null);
    api("get", "/admin/billing/webhook-log", null, { params: { hasil } }).then(setItems).catch(() => setItems([]));
  }, [api, hasil]);
  return (
    <div className="space-y-4" data-testid="admin-webhook-log">
      <p className="text-sm text-mute max-w-2xl">100 webhook OnPay terkini yang diterima, berserta keputusan padanan automatik.</p>
      <div className="flex gap-2 flex-wrap">
        {FILTERS.map(([v, l]) => (
          <button key={v || "all"} onClick={() => setHasil(v)} data-testid={`webhook-filter-${v || "all"}`}
            className={`h-8 px-3 rounded-full text-xs border border-line transition-colors ${hasil === v ? "bg-ink text-bg" : "hover:bg-surface"}`}>{l}</button>
        ))}
      </div>
      {!items ? <Loader2 className="animate-spin text-q" /> : (
        <div className="rounded-xl border border-line overflow-x-auto surface">
          <Table>
            <TableHeader><TableRow><TableHead>Tarikh</TableHead><TableHead>Aktiviti</TableHead><TableHead>Emel</TableHead><TableHead className="text-right">Jumlah</TableHead><TableHead>Invois</TableHead><TableHead>Status</TableHead><TableHead /></TableRow></TableHeader>
            <TableBody>
              {items.map((w) => {
                const [label, cls] = HASIL[w.hasil] || [w.hasil, ""];
                return (
                  <TableRow key={w.id} data-testid={`webhook-row-${w.id}`}>
                    <TableCell className="text-xs font-mono-data">{masa(w.created_at)}</TableCell>
                    <TableCell className="text-xs">{w.event || "—"}</TableCell>
                    <TableCell className="text-sm">{w.email || (w.payload?.ip ? `IP ${w.payload.ip}` : "—")}</TableCell>
                    <TableCell className="text-right font-mono-data">{w.amount_sen != null ? rm(w.amount_sen) : "—"}</TableCell>
                    <TableCell className="text-xs font-mono-data">{w.invois || "—"}</TableCell>
                    <TableCell><span className={`text-xs px-2 py-0.5 rounded-full ${cls}`} data-testid={`webhook-status-${w.id}`}>{label}</span></TableCell>
                    <TableCell><button onClick={() => setSel(w)} className="text-sm text-q underline underline-offset-4" data-testid={`webhook-view-${w.id}`}>Payload</button></TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {items.length === 0 && <p className="p-4 text-sm text-mute" data-testid="webhook-empty">Tiada rekod.</p>}
        </div>
      )}
      <Dialog open={!!sel} onOpenChange={(o) => !o && setSel(null)}>
        <DialogContent className="max-w-2xl" data-testid="webhook-payload-dialog">
          <DialogHeader><DialogTitle>Payload webhook</DialogTitle></DialogHeader>
          <pre className="text-xs bg-surface rounded-lg p-4 max-h-[60vh] overflow-auto whitespace-pre-wrap break-all">{sel && JSON.stringify(sel.payload, null, 2)}</pre>
        </DialogContent>
      </Dialog>
    </div>
  );
};
